/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiCreateScenarioHttpDto,
  ApiFamilyMemberScenarioResponse,
  ApiLegacyScenarioResponse,
  ApiUpdateScenarioDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class Scenario<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerCreateScenario
   * @summary Create a new scenario
   * @request POST:/scenario
   * @secure
   * @response `201` `void`
   */
  scenarioControllerCreateScenario = (
    data: ApiCreateScenarioHttpDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/scenario`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerGetAllScenarios
   * @summary Get all scenarios
   * @request GET:/scenario
   * @secure
   * @response `200` `(ApiLegacyScenarioResponse)[]` Scenarios successfully retrieved
   * @response `404` `void` Scenario not found
   */
  scenarioControllerGetAllScenarios = (params: RequestParams = {}) =>
    this.request<ApiLegacyScenarioResponse[], ApiBaseError>({
      path: `/scenario`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerUpdateScenario
   * @summary Update a scenario
   * @request PUT:/scenario/{id}
   * @secure
   * @response `200` `void`
   */
  scenarioControllerUpdateScenario = (
    id: string,
    data: ApiUpdateScenarioDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/scenario/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerDeleteScenario
   * @summary Delete a scenario
   * @request DELETE:/scenario/{id}
   * @secure
   * @response `204` `boolean` Scenario successfully deleted
   */
  scenarioControllerDeleteScenario = (id: string, params: RequestParams = {}) =>
    this.request<boolean, ApiBaseError>({
      path: `/scenario/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerGetScenario
   * @summary Get a scenario by ID
   * @request GET:/scenario/{id}
   * @secure
   * @response `200` `ApiLegacyScenarioResponse` Scenario successfully retrieved
   * @response `404` `void` Scenario not found
   */
  scenarioControllerGetScenario = (id: string, params: RequestParams = {}) =>
    this.request<ApiLegacyScenarioResponse, ApiBaseError>({
      path: `/scenario/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerRunAllScenarios
   * @summary Run all scenarios
   * @request POST:/scenario/run-all
   * @secure
   * @response `200` `boolean` Scenarios successfully run
   */
  scenarioControllerRunAllScenarios = (params: RequestParams = {}) =>
    this.request<boolean, ApiBaseError>({
      path: `/scenario/run-all`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerCancelAllScenarios
   * @summary Cancel all scenarios
   * @request POST:/scenario/cancel-all
   * @secure
   * @response `200` `boolean` Scenarios successfully canceled
   */
  scenarioControllerCancelAllScenarios = (params: RequestParams = {}) =>
    this.request<boolean, ApiBaseError>({
      path: `/scenario/cancel-all`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerRunScenarioImmediately
   * @summary Run scenario Immediately
   * @request POST:/scenario/{id}/run
   * @secure
   * @response `200` `boolean` Scenario successfully run
   */
  scenarioControllerRunScenarioImmediately = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<boolean, ApiBaseError>({
      path: `/scenario/${id}/run`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerGetAllFamilyMemberScenarios
   * @summary Get all scenarios by Family Member
   * @request GET:/scenario/fm
   * @secure
   * @response `200` `(ApiFamilyMemberScenarioResponse)[]` Scenarios successfully retrieved
   * @response `404` `void` Scenario not found
   */
  scenarioControllerGetAllFamilyMemberScenarios = (
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyMemberScenarioResponse[], ApiBaseError>({
      path: `/scenario/fm`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerActivateScenario
   * @summary Activate a scenario
   * @request POST:/scenario/{id}/activate
   * @secure
   * @response `200` `ApiLegacyScenarioResponse` Scenario successfully activated
   * @response `404` `void` Scenario not found
   */
  scenarioControllerActivateScenario = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<ApiLegacyScenarioResponse, ApiBaseError>({
      path: `/scenario/${id}/activate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerCancelScenario
   * @summary Cancel a scenario
   * @request POST:/scenario/{id}/cancel
   * @secure
   * @response `200` `ApiLegacyScenarioResponse` Scenario successfully cancelled
   * @response `404` `void` Scenario not found
   */
  scenarioControllerCancelScenario = (id: string, params: RequestParams = {}) =>
    this.request<ApiLegacyScenarioResponse, ApiBaseError>({
      path: `/scenario/${id}/cancel`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenario
   * @name ScenarioControllerScenarioViewed
   * @summary Mark scenario as viewed
   * @request POST:/scenario/{id}/viewed
   * @secure
   * @response `200` `boolean` Scenario successfully marked as viewed
   */
  scenarioControllerScenarioViewed = (id: string, params: RequestParams = {}) =>
    this.request<boolean, ApiBaseError>({
      path: `/scenario/${id}/viewed`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
}
